//import Progress from './Progress';
import './styles.scss';

import React from 'react';
// import { Nav } from 'react-bootstrap';
import {
    Outlet
} from 'react-router-dom';

function ClientComplete() {

    return (
        <>
            <Outlet />
        </>
    );
}

export default ClientComplete;
